import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import * as Constants from '../../../../../helpers/constants'
import { ApiHelper } from './../../../../../helpers/apihelper'
import showToastNotification from '../../../../widgets/toastify'
import ConfirmationModal from '../../../../../helpers/confirmationModal'

const AttachBFSProduct = ({ client, userData, getUserInfo }) => {
  const id = useSelector((state) => state.user.id)
  const userName = useSelector((state) => state.user.name)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const handleAttachClick = () => setShowConfirmModal(true)

  const handleConfirmAttach = () => {
    setShowConfirmModal(false)
    const requestBody = {
      co_user_id: userData.user_id,
      cop_user_id: userData.user_id,
      crm_user_data: JSON.stringify({ user_id: id, name: userName }),
      client_secret: Constants.CLIENT_SECRET,
    }

    const body = _.pick(requestBody, ApiHelper(client, 'ATTACH_BFS_PRODUCT').API_BODY)

    ApiHelper(client, 'ATTACH_BFS_PRODUCT').API(client, body)
      .then((response) => {
        if (response?.status === Constants.CO_API.SUCCESS) {
          const message = response?.data?.message || 'BFS plan attached successfully!'
          showToastNotification({ message, isSuccess: true })
          getUserInfo()
        } else {
          const message = response?.message || 'Something went wrong !!!'
          showToastNotification({ message, isSuccess: false })
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <>
      <Button
        className='attach-product-btn'
        variant='outline-primary'
        onClick={handleAttachClick}
      >
        Attach BFS Plan
      </Button>
      <ConfirmationModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmAttach}
        title='Attach BFS Plan'
        message='Are you sure you want to attach this BFS plan to the user?'
        confirmText='Yes, Attach'
        cancelText='Cancel'
      />
    </>
  )
}

export default AttachBFSProduct
